<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('datalevels')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
    </l-container>

    <hot-table :data="providers" :settings="settings" ref="hot" :key="componentKey">
      <hot-column :title="this.$t('value')" data="value" read-only="true"></hot-column>
      <hot-column :title="this.$t('description')" data="description" read-only="false"></hot-column>
      <hot-column title="Atom" data="atom" read-only="false"></hot-column>
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import DatalevelsService from "../../../helpers/apiservices/datalevels/datalevels.service";
import Notify from "@/helpers/notify";

export default {
  name: "datalevels",
  components: {
    HotTable,
    HotColumn,
  },
  data() {
    return {
      providers: [],
      settings: HandsontableHelper.settings(false),
      componentKey: 0
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);

     //forcing recreation of hot-table since nor re-rendering of table or edit settings updated headers
    this.$root.$on('rendertable', () => {
      this.componentKey += 1;
    }); 

  },

  methods: {
    async loadInitialData() {
      this.providers = await DatalevelsService.datalevels();
    },

  }
};
</script>

<style  scoped>
  button {
      padding: 15px;
      border: 1px solid green;
      font-size: 18px;
      margin: 15px;
  }
</style>



